import { render, staticRenderFns } from "./AnnouncementsBar.vue?vue&type=template&id=041eca3a&scoped=true&lang=pug"
import script from "./AnnouncementsBar.vue?vue&type=script&lang=js"
export * from "./AnnouncementsBar.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementsBar.vue?vue&type=style&index=0&id=041eca3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041eca3a",
  null
  
)

export default component.exports